<script>
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AssetDataTable from '@/components/asset/AssetDataTable.vue';
import AssetDataChip from '@/components/asset/AssetDataChip.vue';
import DataTable from '@/components/ui/Table/DataTable.vue';
import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import AppDialog from '@/components/app/AppDialog.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import AssetInfoDrawer from '@/components/asset/AssetInfoDrawer.vue';
import EncodeOptionTable from '@/components/asset/EncodeOptionTable.vue';
import AssetPlayer from '@/components/asset/AssetPlayer.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import Alert from '@/components/app/AppAlert.vue';
// import AssetCard from '@/components/asset/AssetCard.vue';
import AssetDrawer from '@/components/asset/AssetDrawer.vue';
import SocialUploadStatusAccordion from '@/components/socialupload/SocialUploadStatusAccordion.vue';
import _ from 'lodash';
import { mapGetters, mapActions, mapState } from 'vuex';
import { get } from 'lodash';
  
export default {
    components: {
        IconTextButton,
        IconButton,
        TextButton,
        AssetDataTable,
        AssetDataChip,
        SearchTextfield,
        AppDialog,
        AppDialogLarge,
        AssetInfoDrawer,
        DataTable,
        EncodeOptionTable,
        TextButtonBlock,
        AssetPlayer,
        Alert,
        AppSnackbar,
        // AssetCard,
        AssetDrawer,
        SocialUploadStatusAccordion,
    },
    data() {
      return {
        flag: true,
        isFirst: true,
        timer: null,
        assetIds: [],
        groupDialog: false,
        showSel: true,
        delDialog: false,
        encodeDialog: false,
        reqEncodeDialog: false,
        // assetInfo: [],
        options: [],
        selected01: [],
        selected02: {},
        reqEncodeList: [],
        playDialog: false,
        delConfirm: false,
        selIdx: null,
        load: false,
        playVal: false,
        check: this.$store.getters['objectData/getStandard']('checkData'),
        selectedId: null,
        statusDatas: null,
        tableDatas: [],
        // watchFlag: false,
        message: '',
        messageType: '',
        isEditing: false,
        newTitle: null,
        editedGroupName: null,
        props: ['item'],
        selectedCards: [],
        dulp: false,
        showDataTable: true,
        // watchFlag02: false,
        snackbar: false,
        snackbarText: '',
        snackbarError: false,
        snackbarErrorText: '',
        reqRes: null,
        interval: null,
        socialJobsInterval: null,
        socialPollingActive: false,
        bulkHideLoading: false,
        allDatas: [],
        previousItems: [],
        intervalRunning: false,
        toggle_exclusive: null,
        checkReq: false,
        page: 1,
        pageCount: 5,
        viewCount: 5,
        delEncodeLoading: false,
        allDelLoading: false,
        searchData: '',
        inGroupLoading: false,
        normalizedSearch: '',
        isComposing: false,
        bitrateOptions: {},
        resolutions: [],
        showSocialStatusModal: true,
        socialStatusManuallyHidden: false,
      };
    },
    // async beforeRouterEnter(to, from, next){
    //     try {
    //         next(vm => {
    //             vm.$store.dispatch('asset/updateCurrentPage', 1);
    //         });
    //         } catch (error) {
    //         console.error('error =>', error);
    //         next(false); 
    //     }
    // },
    methods: {
        ...mapActions('asset', ['updateFlag', 'fetchAllAsset', 'updateCurrentPage', 'fetchStatus', 'updateRowsPerPage', 'updateSearch', 'refreshList', 
        'grouping', 'fetchGroupList', 'fetchInGroupInfo', 'updateGroupIds', 'delAssetDatas', 'updateDrawer', 'noEmptyload', 'fetchAllList',
        'updateClickBtn', 'insertReqEncodeData', 'fetchGroupListItems', 'fetchDetailId', 'delSingle', 'loadList', 'updateGroup', 'checkEncoding', ]),
        ...mapActions('group', ['updateSelectedItems', 'updateGroupList']),
        ...mapActions('upload', {
            hideSocialJobOnServer: 'hideSocialJob',
            hideAllSocialJobsFromStore: 'hideAllSocialJobs',
            cancelSocialJobOnServer: 'cancelSocialJob',
            fetchSocialJobsFromStore: 'fetchSocialJobs',
        }),
        startSocialPolling() {
            if (this.socialJobsInterval) return;
            this.socialJobsInterval = setInterval(() => {
                this.fetchSocialJobsFromStore();
            }, 3000);
            this.socialPollingActive = true;
        },
        stopSocialPolling() {
            if (this.socialJobsInterval) {
                clearInterval(this.socialJobsInterval);
                this.socialJobsInterval = null;
            }
            this.socialPollingActive = false;
        },
        syncSocialPollingState() {
            if (this.hasActiveSocialJobs) {
                this.startSocialPolling();
            } else {
                this.stopSocialPolling();
            }
        },
        // async previousPage() {
        //     if (this.currentPage > 1) {
        //         // this.updateCurrentPage(this.currentPage - 1);
        //         const data = this.currentPage -1;
        //         this.$store.dispatch('asset/updateCurrentPage', data);
        //         this.dataLoading();
        //     }
        // },
        // async nextPage() {
        //     if (this.hasNextPage) {
        //         // this.updateCurrentPage(this.currentPage + 1);
        //         const data = this.currentPage + 1;
        //         this.$store.dispatch('asset/updateCurrentPage', data);
        //         this.dataLoading();
        //     }
        // },
        async previousPage() {
            const newPage = this.currentPage -1;
            if (this.currentPage > 1) {
                // this.updateCurrentPage(this.currentPage - 1);
                if (!this.watchFlag) {
                    
                    this.$store.dispatch('asset/updateCurrentPage', newPage);
                    this.dataLoading();
                } else {
                   
                    const params = {
                        group_id: this.group_id,
                        page: newPage,
                        rowsPerPage: 10
                    };
                    const res = await this.fetchGroupListItems(params);
                    if (res.status === 1) {
                        this.tableDatas = res.list;
                        //console.log("this.tableDatas => ", this.tableDatas)
                        this.$store.commit('asset/setTotal', res.total);
                        this.$store.dispatch('asset/updateCurrentPage', newPage);
                        //console.log("res.list => ", res.list)
                        this.$store.commit('asset/setLoading', false);
                        //this.dataLoading();
                    }
                }

            }
        },
        async nextPage() {
            const newPage = this.currentPage + 1;
            if (this.hasNextPage) {

                if (!this.watchFlag) {
                    // this.updateCurrentPage(this.currentPage + 1);
                    
                    this.$store.dispatch('asset/updateCurrentPage', newPage);
                    this.dataLoading();
                } else {

                    const params = {
                        group_id: this.group_id,
                        page: newPage,
                        rowsPerPage: 10
                    };
                    
                    const res = await this.fetchGroupListItems(params);
                    if (res.status === 1) {
                        this.tableDatas = res.list;
                        //console.log("this.tableDatas => ", this.tableDatas)
                        this.$store.commit('asset/setTotal', res.total);
                        this.$store.dispatch('asset/updateCurrentPage', newPage);
                        //console.log("res.list => ", res.list)
                        this.$store.commit('asset/setLoading', false);
                        //this.dataLoading();
                    }
                }


            }
        },
        // async load(){
        //     const fetchAllAssetPromise = this.fetchAllAsset();
        //     const fetchStatusPromise = this.fetchStatus();

        //     await Promise.all([fetchAllAssetPromise, fetchStatusPromise]);
        // },
        updatePage(page){
            if (page === 'prev') {
                if (page > 1) {
                    this.updateCurrentPage(page - 1);
                }
            } else if (page === 'next') {
                if (this.hasNextPage) {
                    this.updateCurrentPage(page + 1);
                }
            } else {
                this.updateCurrentPage(page);
            }
        },
        updatePageRow(page){
            this.updateRowsPerPage(page);
            this.dataLoading();
            // console.log("업데이트 후, 리스트 => ", this.tableDatas)
        },
        async refresh(){
            this.assetIds = [];
            this.tableDatas = [];
            // this.drawer = false;
            this.updateDrawer(false);
            this.tableDatas = await this.refreshList();
        },
        async openModal(dialogName){
            this.updateDrawer(false);
            if(this.assetIds.length > 0){
                this[dialogName] = true;  
                if(dialogName === 'groupDialog'){
                    // console.log("this.groupStatus : ", groupStatus)
                    if(this.assetIds.length === 1 ){
                        const asset_id = this.assetIds.map(e => e.assetId);
                        await this.fetchInGroupInfo(asset_id);
                    }
                }                
            }
            else {
                // v-alert??
            }
        },
        playVideo(){
            // console.log("playVideo 클릭????")
            const check = this.checkStatus();
            if(check){
                //console.log("check들어옴 => ", this.playerUrl)
                //console.log("modal true")
                this.playVal = true;
            }
        },
        closeVideo(){
            this.playVal = false;
        },
        checkStatus(){
            // const statusArr = this.assetInfo.status.map(e => e.status);
            // const res =  statusArr.every(function(status) {
            //     return status === 'encoded';
            // });
            // console.log("상태확인 res => ", res)
            // return res;
            // const sortOut = this.assetInfo.sortOut;
            // const statusArr = sortOut.map(e => e.status);
            // const sortOut = this.assetInfo.encodingInfo;
            // const statusArr = sortOut.map(e => e.status);
          
            // const res =  statusArr.some(function(status) {
            //     return status === 'encoded';
            // });
            const checkStat = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing';
            //console.log("상태확인 res => ", checkStat)
            return checkStat;
        },
        async inGroup(){
            this.inGroupLoading = true;
            const params = {
                assetIds: this.assetIds.map(e => e.assetId),
                groupIds: this.selected
            };
            const res = await this.grouping(params);
            if(res === 1){
                this.inGroupLoading = false;
                this.closeDialog('groupDialog');
                // this.$router.go();
                // this.dataLoading();
                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('동영상 그룹핑에 성공했습니다.');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.dataLoading();
                        this.snackbar = false;
                    }, 2000);
                }, 1000);
            }
            else {
                this.inGroupLoading = false;
                this.closeDialog('groupDialog');

                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('동영상 그룹핑에 실패하였습니다.');
                    this.snackbarError = true;
                    setTimeout(() => {
                        this.snackbar = false;
                        this.dataLoading();
                    }, 2000);
                }, 1000);
            }
        },
        enterSelect(value) {
            this.assetIds = value;
        },
        closeDialog(dialogName){
            const action = {
                'groupDialog': () => {
                    this.$store.commit('asset/setEmptyGroupIds');
                    this.showSel = false;
                    this.page = 1;
                },
                'encodeDialog': () => {
                    this.clearOption();
                    this.fetchOptions();
                },
                'reqEncodeDialog': () => {
                    this.fetchOptions();
                },
                'encodeDialogAll': () => {
                    // this.selected01 = [];
                    // this.setInit();
                    this.clearOption();
                    this.fetchOptions();
                    this['reqEncodeDialog'] = false;
                    this['encodeDialog'] = false;
                },
                'delConfirm': () => {
                    this.delEncodeLoading = false;
                    this.clearOption();
                    this.fetchOptions();
                },
            };

            if (action[dialogName]) {
                action[dialogName]();
            }
            this.assetIds = [];
            this[dialogName] = false;
        },
        updateSelected(val){
            this.updateGroupIds(val);
        },
        async delAssets(){
            this.updateDrawer(false);
            this.allDelLoading = true;
            // this.selectedId = null;
            // const keys = this.assetIds.map(e => e.aid);
            //this.assetIds.map(e => e.aid + '/' + e.filename);
            const params = {
                assetIds: this.assetIds.map(e => e.assetId),
                // keys: keys
            }
            const res = await this.delAssetDatas(params);
            //console.log("전체삭제 => ", res)
            if(res === 1){
                this.allDelLoading = false;
                this.closeDialog('delDialog');
                // this.$router.go();

                // this.snackbar = true;
                // this.snackbarText = this.$store.getters.t('데이터 삭제에 성공했습니다.');
                // this.snackbarError = false;

                // setTimeout(() => {
                //     this.dataLoading();
                //     this.snackbar = false;
                //     this.updateDrawer(false);
                // }, 2000);


                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('데이터 삭제에 성공했습니다.');
                    this.snackbarError = false;
                    // setTimeout(() => {
                    //     this.dataLoading();
                    //     this.snackbar = false;
                    //     this.updateDrawer(false);
                    // }, 2000);
                }, 1000);

                // this.refresh();
            }
            else {
                // this.allDelLoading = false;
                //  this.snackbar = true;
                // this.snackbarText = this.$store.getters.t('데이터 삭제에 실패하였습니다.');
                // this.snackbarError = true;

                setTimeout(() => {
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('데이터 삭제에 실패하였습니다.');
                this.snackbarError = true;
                    // setTimeout(() => {
                    //     this.snackbar = false;
                    //     this.updateDrawer(false);
                    //     this.dataLoading();
                    // }, 2000);
                }, 1000);    
            }

            this.snackbar = false;
            this.snackbarError = false;
            
            this.$store.commit('asset/setAssetInfo', []); 

            this.updateDrawer(false);
            this.dataLoading();
            this.fetchAll(); 
        },

        convertToObject(item) {
            if (Array.isArray(item)) { 
                const obj = {}; 
                data.forEach((value, index) => { 
                    obj[index] = value;
                });
                return obj; 
            } else {
                return item; 
            }
        },
        setCrf(resolution){
            // console.log("resolution => ", resolution)
            // switch (resolution) {
            //     case '1080p':
            //         return ['2M', '4M', '6M'];
            //     case '720p':
            //         return ['1M', '2M', '4M'];
            //     case '480p':
            //         return ['500k', '1M', '2M'];
            //     default:
            //         return ['500k', '1M', '2M'];
            // }
            return this.bitrateOptions[resolution] || this.bitrateOptions['default'] || [];
        },
        async showInfo(item){
            
            // console.log("버튼확인", item)
            this.selectedId = item.assetId;
            // load info
            // this.assetInfo = this.items.find(e => e.assetId === this.selectedId);
            // console.log("this.assetInfo 확인 => ", this.assetInfo);

            // const params = {
            //     asset_id: this.selectedId
            // }
            // const reqCheck = await this.checkEncoding(params);
            // console.log("reqCheck => ", reqCheck)

            this.$store.commit('asset/setAssetInfo', item);

            this.resolutions = this.updateResolutions();
            // console.log("resolutions => ", this.resolutions)
            
            this.fetchOptions();

            // this.fetchOptions();
            this.load = true;
            this.updateDrawer(true);
            // let img = null;
            // let type = [];

            // // console.log("확인1 => ", item);
            // const encodeInfo = Object.values(item.encodingInfo).map(e => e);
            // img = encodeInfo.map(e => e.thumbnail)[0] ?? null;
            // // const statusInfo = item.statusList.map(e => e);
            // const statusInfo = item.encoding_type.flatMap(e => e);
            // console.log("타입 확인 => ", statusInfo)

            // const result = this.check.map(resolution => {
            //     const found = statusInfo.find((e) => {
            //         return e === resolution
            //     });
            //     console.log("found => ", found);
            //     let status;
            //     if (found !== undefined) { 
            //         const tmp = item.status.find(e => e.encoding_resolution+'p' === found).status;
            //         console.log("tmp => ", tmp);
            //         status = tmp;
            //     } else {
            //         status = '!black';
            //     }
            //         return {
            //             resolution: resolution,
            //             status: status
            //         };

            // });

            // type = result;
          
            // this.assetInfo = {
            //         ...item,
            //         image: img,
            //         statusInfo: statusInfo,
            //         types: type,
            //     }; 
            //     console.log("여기여기 ~ ", this.assetInfo)
           
        },
        closeBtn(){
            this.updateDrawer(false);
            this.$store.commit('asset/setAssetInfo', []);
        },
        clearOption(){
            this.selected01 = [];
            this.setInit();
            this.message = '';
            this.messageType = '';
        },
        checkClick(){ // 인코딩 + 버튼
            this.updateClickBtn(!this.isClick);
            if(this.assetInfo && this.isClick){
                this.encodeDialog = this.isClick;
            }
        },
        fetchOptions(){
            // this.options = [
            //     { label: '프레임', items: this.fpsOptions },
            //     { label: '화질', items: this.crfOptions },
            //     { label: '음질', items: this.audioOptions },
            //     { label: '인코딩 속도', items: this.presetOptions }
            // ];
            // if(this.resolutions){
            //     for (const item of this.resolutions) {
            //         const resolution = item.label;
            //          this.options = [
            //             { label: '프레임', items: this.fpsOptions },
            //             { label: '비트레이트', items: this.crfOptions[resolution]},
            //             { label: '음질', items: this.audioOptions },
            //             { label: '인코딩 속도', items: this.presetOptions }
            //         ];  
            //     }
            // }
            this.options = [
                    { label: this.$store.getters.t('프레임'), items: this.fpsOptions },
                    { label: this.$store.getters.t('비트레이트'), items: this.crfOptions},
                    { label: this.$store.getters.t('음질'), items: this.audioOptions },
                    { label: this.$store.getters.t('인코딩 속도'), items: this.presetOptions }
                    // { label: this.name_frame, items: this.fpsOptions },
                    // { label: this.name_bitrate, items: this.crfOptions},
                    // { label: this.name_audio, items: this.audioOptions },
                    // { label: this.name_preset, items: this.presetOptions }
            ];  

            this.setInit();
        },
        getDefaultItem(items) {
            return items.length > 0 ? items[0] : null;
        },
        initSelValues(){
            if(this.resolutions){
                for (const item of this.resolutions) {
                    this.selected02[item.label] = {};
                    for (const option of this.options) {
                        this.selected02[item.label][option.label] = [];
                    }
                }  
            } else {
                this.selected02 = {};
            }

        },  
        getItems(label) {
            // console.log("[getItems] => ", label)
            const item = this.options.find(item => item.label === label);
            return item ? item.items : [];
        },
        logSelection(item, selectedValues) {
            item.selectedValues = selectedValues;
            // console.log("Selected 1:", selectedValues);
        },
        async handleConfirmation(){
            this.reqEncodeList = [];
            if(this.selected01.length === 0){
                // v-alert 경고창
                this.message = this.$store.getters.t('해상도 옵션을 선택해주세요.');
                this.messageType = 'error';

                setTimeout(() => {
                    this.message = '';
                    this.messageType = '';
                }, 3000);
            } else {
                const selDatas = {
                    checkboxes: this.selected01,
                    selects: this.selected02,
                };
                // console.log("handleConfirmation ==> ", selDatas);

                const datasObject = {};
                selDatas.checkboxes.forEach(key => {
                    if (selDatas.selects.hasOwnProperty(key)) {
                        datasObject[key] = selDatas.selects[key];
                    }
                });

                const tmp = selDatas.checkboxes.map(key => ({
                    // fps: datasObject[key]?.프레임,
                    // crf: datasObject[key]?.비트레이트,
                    // audio: datasObject[key]?.음질,
                    // preset: datasObject[key]?.['인코딩 속도']
                    fps: datasObject[key]?.[this.$store.getters.t('프레임')],
                    crf: datasObject[key]?.[this.$store.getters.t('비트레이트')],
                    audio: datasObject[key]?.[this.$store.getters.t('음질')],
                    preset: datasObject[key]?.[this.$store.getters.t('인코딩 속도')]
                }));
                
                tmp.forEach((e, idx) => {
                    const upload_direction = this.assetInfo.upload_direction;
                    const datas = {
                        type: selDatas.checkboxes[idx],
                        upload_direction: upload_direction
                    };

                    const assetData = {
                        selResolution: this.getSelResolutions(datas),
                        ...this.assetInfo,
                    };

                    const data = {
                        ...e,
                        assetData,
                    }
                    this.reqEncodeList.push(data);
                });


                // console.log("this.reqEncodeList => ", this.reqEncodeList)
                this.encodeDialog = false;
                this.reqEncodeDialog = true;
            }
        },
        setInit(){
            // console.log("this.resolutions => ", this.resolutions)
            if(this.resolutions){
                for (const item of this.resolutions) {
                    this.$set(this.selected02, item.label, {});
                    
                    for (const option of this.options) {
                        let sel;
                        if (option.label === this.$store.getters.t('비트레이트')) {
                            sel = option.items[item.label]?.[1] ?? null;
                        } else {
                            sel = option.items?.[0] ?? null;
                        }

                        this.$set(this.selected02[item.label], option.label, sel);
                    }
        
                    // for (const option of this.options) {
                    //     this.$set(this.selected02[item.label], option.label, option.items[0]); 
                    // }
                }

                // for (const item of this.resolutions) {

                //     const resolution = item.label;

                //     this.$set(this.selected02, resolution, {});

                //     // console.log("확인 => ", Array.isArray(this.crfOptions[resolution]));  
                //     // console.log(this.crfOptions[resolution].map(i => typeof i));


                //     const options = [
                //         { label: '프레임', items: this.fpsOptions },
                //         { label: '비트레이트', items: Object.values(this.crfOptions[resolution])},
                //         { label: '음질', items: this.audioOptions },
                //         { label: '인코딩 속도', items: this.presetOptions }
                //     ];

                //     this.$set(this.options, resolution, options);
                //     // console.log("options 11=> ", this.options)
                    
                //     for (const option of options) {
                //         // console.log(option.label, option.items)
                //         this.$set(this.selected02[resolution], option.label, option.items[0]); 
                //     }
                // }
            }
            // console.log("this.selected02 33 => ", this.selected02) 
            


        },
        updateSelected01(val){
            // console.log("여기 -> ", val)
            this.selected01 = val;
        },
        // updateResolutions(){
        //     // const data = [this.assetInfo].map((e) => e.encoding_type);
   
        //     if(this.assetInfo){
        //         const tmp = this.assetInfo.encodingInfo;
        //         const data = tmp.map(e => e.type);

        //         if(this.drawer && this.load && this.dataLoad && this.assetInfo){
        //             const resolutions_arr = [];
                    
        //             let tmpVal;
        //             const direction = this.assetInfo.upload_direction;
        //             if(direction === '가로'){
        //                 tmpVal = this.assetInfo.upload_resolution.split('x')[1];
        //                 resolutions_arr.push(Number(tmpVal));
        //             }
        //             else if(direction === '세로'){
        //                 tmpVal = this.assetInfo.upload_resolution.split('x')[0];
        //                 resolutions_arr.push(Number(tmpVal));
        //             }

        //             const val = resolutions_arr.length ? resolutions_arr.reduce((a, b) => {
        //                 return a > b ? a : b;
        //             }) : null;
        //             // console.log("해상도 확인2222 => ", val)

        //             const upload_resolution = val;
        //             const check = [1080,720,480];
        //             var arr = [];
        //             // for (let i = 0; i < check.length; i++) {
        //             //     if (check[i] < upload_resolution) {
        //             //         arr.push(check[i] + 'p');
        //             //     }
        //             // }
                    
        //             arr = check.filter(e => e < upload_resolution).map(e => e + 'p');
        //             if(arr.length === 0){
        //                 arr.push('480p');
        //             }
        //             const res = arr.map(e => {
        //                 return { label: e };
        //             });
                    
        //             // console.log("해상도 확인1111 => ", res)
        //             return res.map(e => e);

        //                 // const temp = [];
        //                 // this.standardVal.checkData.forEach(e => {
        //                 //     if (!data.includes(e)) {
        //                 //         temp.push(e);
        //                 //     }
        //                 // });
        //                 // const res = temp.map(e => {
        //                 //     return { label: e };
        //                 // });
                        
        //                 // return res.map(e => e);
        //         }
        //         else {
        //             const temp = this.standardVal.checkData?.filter(e => {
        //                 const encodingType = data;
        //                 return encodingType && !encodingType.includes(e);
        //             }) || [];

        //             const res = temp.map(e => {
        //                 return { label: e };
        //             });
                   
        //             return res;
        //         }
        //     }
        //     else {
        //         return null;
        //     }
        //     // const data = this.assetInfo.encoding_type;
        //     // const info = [this.assetInfo].map(e => e.encodingInfo.map(e => Object.values(e)[0]))[0];
        //     // const data = info.map(e=>e.type);
            
    
        // },
        updateResolutions(){
            if(this.assetInfo){
                // const tmp = this.assetInfo.encodingInfo;
                // const data = tmp.map(e => e.type);

                const resolutions_arr = [];

                let tmpVal;
                const direction = this.assetInfo.upload_direction;
                if(direction === '가로'){
                    tmpVal = this.assetInfo.upload_resolution.split('x')[1];
                    resolutions_arr.push(Number(tmpVal));
                }
                else if(direction === '세로'){
                    tmpVal = this.assetInfo.upload_resolution.split('x')[0];
                    resolutions_arr.push(Number(tmpVal));
                }

                const val = resolutions_arr.length ? resolutions_arr.reduce((a, b) => {
                    return a > b ? a : b;
                }) : null;

                const upload_resolution = val;
                const check = [1080, 720, 480];
                var arr = [];

                arr = check.filter(e => e < upload_resolution).map(e => e + 'p');
                if(arr.length === 0){
                    arr.push('480p');
                }
                const res = arr.map(e => {
                    return { label: e };
                });
                

                return res.map(e => e);
            } else {
                const temp = this.standardVal.checkData.filter(e => {
                    const encodingType = data;
                    return encodingType && !encodingType.includes(e);
                }) || [];

                const res = temp.map(e => {
                    return { label: e };
                });
                
                return res;
            }
        },
        getSelResolutions(datas) {
            const direction = datas.upload_direction;
            const type = datas.type;
            const data = this.standardVal.fixedData[type];
            let val = null;
            if(data){
                val = direction === '가로' ? data.가로 : data.세로;
            }
            return val;
        },
        editBtn(){
            // this.fetchDetailInfo(this.assetInfo);
            if(sessionStorage.getItem('AccessToken') == null) return;

            this.fetchDetailId(this.assetInfo.assetId);
            this.$router.push({name: 'asset-modify'});
        },
        async sendReqEncode(){
            this.closeDialog('encodeDialogAll');
            this.updateDrawer(false);
            this.checkReq = true;

            try {
                
                for(let i=0; i<this.reqEncodeList.length; i++){
                    const data = this.reqEncodeList[i];
                    // console.log("data => ", data)
                    this.reqRes = await this.insertReqEncodeData(data);
                }
                if(this.reqRes === 1){
                    // this.snackbar = true;
                    // this.snackbarText = this.$store.getters.t('인코딩 요청이 등록되었습니다.');
                    // this.snackbarError = false;

                    // setTimeout(() => {
                    //     this.snackbar = false;
                    //     this.snackbarText = '';
                    //     this.clearOption();

                    //     // this.$router.go(); 
                    // }, 3000);

                    setTimeout(() => {
                        this.snackbar = true;
                        this.snackbarText = this.$store.getters.t('인코딩 요청이 등록되었습니다.');
                        this.snackbarError = false;

                        setTimeout(() => {
                            this.snackbar = false;
                            this.snackbarText = '';
                            this.clearOption();
                        }, 3000);
                    }, 1000);
                    // this.interval = setInterval(this.dataLoading.bind(this), 5000);
                }
                else {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('인코딩 요청에 실패하였습니다.');
                    this.snackbarError = true;

                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarError = false;
                        this.snackbarText = '';
                        this.clearOption();

                        // this.$router.go(); 
                    }, 2000);
                    // this.interval = setInterval(this.dataLoading.bind(this), 5000);
                }
             
            } catch (error) {
                console.log("인코딩 요청 error => ", error);
            } finally {
                this.checkReq = false;

                this.$store.commit('asset/setAssetInfo', []); 

                await this.dataLoading();
            }

        },
        extractNumbersFromString(str) {
            const regex = /\d+/g; 
            // console.log("str => ", str)
            return str.match(regex);
        },
        // loadPlay() {
        //     console.log("load 플레이")
        //     const iframe = this.$refs.assetPlayer;
        //     if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) return;

        //     const video = iframe.contentWindow.document.querySelector('video');
        //     if (!video) return;

        //     const myVideoContainer = iframe.contentWindow.document.querySelector('.my-video-container');
        //     const plyrControls = iframe.contentWindow.document.querySelector('.plyr__controls');
        //     console.log('iframe', iframe);
        //     console.log('video', video);
        //     console.log('myVideoContainer', myVideoContainer);
        //     console.log('plyrControls', plyrControls);

        //     if (video) {
        //         video.muted = true;
        //         video.volume = 0;
        //     }
           
        //     video.autoplay = true;
        //     video.play();
        // },
        delBtn(id){
            //console.log("del => ", id);
            this.selIdx = id;
            this.delConfirm = true;
        },
        async deleteEncodeFile(){
            this.delEncodeLoading = true;
            // const aid = this.encodeInfoList.map(e => e.aid)[0];
            const aid = this.assetInfo.aid;
            const params = {
                asset_id: this.selIdx,
                aid: aid
                // path 해상도 체크 필요
            };

            this.updateDrawer(false);
            const res = await this.delSingle(params);
            this.selectedId = null;
            if(res === 1){
                // v-snackbar 삭제성공
                this.delEncodeLoading = false;
                this.closeDialog('delConfirm');
                // this.$router.go();
                // this.dataLoading();
                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('인코딩 파일 삭제에 성공했습니다.');
                    this.snackbarError = false;
                    this.tableDatas = [];
                    // this.assetInfo = null;
                    this.$store.commit('asset/setAssetInfo', []); 
                    this.dataLoading();
                    this.fetchAll(); 
                    setTimeout(() => {
                        // this.dataLoading();
                        this.snackbar = false;
                    }, 2000);
                }, 1000);
            }
            else {
                // v-snackbar 삭제실패
                this.delEncodeLoading = false;
                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('인코딩 파일 삭제에 실패하였습니다.');
                    this.snackbarError = true;
                    this.tableDatas = [];
                    // this.assetInfo = null;
                    this.$store.commit('asset/setAssetInfo', []); 
                    this.dataLoading();
                    this.fetchAll(); 
                    setTimeout(() => {
                        this.snackbar = false;
                        // this.dataLoading();
                    }, 2000);
                }, 1000);
            }
        },
        getName(){
            if(this.assetInfo){
                const data = this.assetInfo.name;
                //console.log("name => " ,this.assetInfo.name)
                return data;
            }
        },
        geUrl(){
            if(this.assetInfo){
                // const data = Object.values(this.assetInfo.encodingInfo).map(e => e.smil_player_url)[0];
                const data = this.assetInfo.playUrl;
                // console.log("url => " ,Object.values(this.assetInfo.encodingInfo).map(e => e.smil_player_url)[0])
                return data;
            }
        },
        getPoster(){
            if(this.assetInfo){
                const data = this.assetInfo.image;
                return data;
            }
        },
        // async testData(){
        //     try {
        //         console.log("[testData]실행")
        //         const res = await AssetApi.testApi();
        //         this.tableDatas = res.data;
        //         setTimeout(this.testData, 30000); 
        //     } catch (error) {
        //         console.error("testData error :", error);
        //     }
        // },
        // handleStatus(e, newVal, oldVal){
        //     console.log(`status변경 ${oldStatus}=>${newStatus}`);
        //     this.noEmptyload(); // e, newVal
        // },
        async getGroups(){
           await this.fetchGroupList();
        },
        handleLoading(){
            // console.log("실행1")
            this.dataLoading();
        },
         async dataLoading() {
            // console.log("실행2 => ", this.watchFlag)
            try {
                // this.tableDatas = [];
                this.intervalRunning = true;
                // const data = await new Promise((resolve, reject) => {
                //     this.loadList().then(resolve).catch(reject);
                // });
                if (!this.watchFlag) {
                    const data = await this.loadList();
                    // console.log("loatlist => ", data)
                    // if (JSON.stringify(data) !== JSON.stringify(this.previousItems)) {
                    //     this.tableDatas = data;
                    //     this.previousItems = JSON.parse(JSON.stringify(data));
                    // }
                    this.tableDatas = data || [];

                    this.tableKey++;

                    // this.$forceUpdate();

                    // this.loadList().then((data) => {
                    //     this.tableDatas = data || [];
                    //     this.$nextTick(() => {
                            this.intervalRunning = false;
                            if(this.tableDatas){
                                const checkItem = this.tableDatas.find(e => e.status === 'processing' || e.status === 'processing ...');
                                if (!checkItem) {
                                    clearInterval(this.interval);
                                }
                            }
                    //     });
                    // });
                }

                // console.log("리스트 확인 [1] > ", this.tableDatas)
            } catch (error) {
                console.error('err loading data:', error);
            }
            // const data = await this.loadList();
            // this.tableDatas = data;
            // console.log("리스트 확인 sortout 1=> ", this.tableDatas.sortOut)
            // // const all = this.tableDatas.flatMap(e => e.map(obj => obj.id));
            // console.log("리스트 확인 sortout 2=> ", this.tableDatas.map(e => e.sortOut).map(e => e.status))
        },
        // handleResize(){
        //     if(this.drawer){
        //         this.updateDrawer();


        //     }
        // },
        async handleDataUpdata(newVal){
            try {
                console.log("[handleDataUpdata]실행")
                // this.loadList();
                this.$store.commit('asset/setLoading', true);
                this.tableDatas = newVal;
                // setTimeout(this.dataLoading, 30000); 
                this.$store.commit('asset/setLoading', false);
            } catch (error) {
                console.error("handleDataUpdata error :", error);
            }
        },
        async fetchAll(){
            try {
                const data = await this.fetchAllList();
                this.allDatas = data;
            } catch (error) {
                console.error('err fetchAll data:', error);
            }
        },
        handleUploadFinished(data){
            // console.log('[uploadFinished] : ', data);
            // if(data === 'close'){
            //     // this.dataLoading();
            //     // this.$router.go();
            // }
        },
        async handleSocialJobHide(jobId) {
            if (jobId === undefined || jobId === null) return;
            try {
                await this.hideSocialJobOnServer(jobId);
            } catch (error) {
                console.error('[AssetForm] Failed to hide social job', error);
            }
        },
        async handleSocialJobCancel(jobId) {
            if (jobId === undefined || jobId === null) return;
            try {
                await this.cancelSocialJobOnServer(jobId);
            } catch (error) {
                console.error('[AssetForm] Failed to cancel social job', error);
            }
        },
        async handleSocialHideAll() {
            if (this.bulkHideLoading) return;
            this.bulkHideLoading = true;
            try {
                await this.hideAllSocialJobsFromStore();
            } catch (error) {
                console.error('[AssetForm] Failed to hide all social jobs', error);
            } finally {
                this.bulkHideLoading = false;
            }
        },
        handleSocialStatusClose() {
            this.showSocialStatusModal = false;
            this.socialStatusManuallyHidden = true;
        },
        onCompositionEnd(event) {
            this.isComposing = false;
            this.updateSearch(event.target.value);
        },
        onInput(event) {
        if (!this.isComposing) {
            this.updateSearch(event.target.value);
        }
        },
        updateSearch(value) {
            // 한글 normalize 처리 (NFC)
            this.searchData = value.normalize('NFC');

            // const tmp = this.normalizedSearch.toLowerCase();
            // this.filteredItems = this.tableDatas.filter(e => 
            //      Object.values(e).some(val =>
            //        String(val).toLowerCase().includes(tmp)
            //     )
            // );
        },
        // isVerticalImage(imageSrc) {
        // },
        // CardSearch(item) {
        //     if (!this.search) return true; // 검색어가 비어 있으면 모든 카드를 보여줍니다.
        //     const searchString = this.search.toLowerCase();
        //     return item.name.toLowerCase().includes(searchString); // 카드 이름이 검색어를 포함하면 카드를 보여줍니다.
        // },
        // toggleCardSelection(item) {
        //     const index = this.selectedCards.indexOf(item);
        //     if (index === -1) {
        //     this.selectedCards.push(item);
        //     } else {
        //     this.selectedCards.splice(index, 1);
        //     }
        // },
        // isSelected(item) {
        //     return this.selectedCards.includes(item);
        // },
    },
    computed: {
        ...mapState('asset', ['watchFlag', 'currentPage', 'loading', 'statusList', 'startIndex', 'endIndex', 'rowsPerPage', 'drawer',
        'itemsPerPageOptions', 'search', 'totalLength', 'isClick', 'dataLoad', 'assetInfo']),
        ...mapState('group', ['selectedGroupId', 'selectedGroupName', 'groupStatus']),
        ...mapState('upload', ['socialJobs']),
        ...mapGetters('asset', ['totalPages', 'groupList', 'groupIds', 'initTotal']),
        ...mapGetters('group', ['selectedItems']),
        ...mapGetters('upload', ['lastCompletedFileName']),
        ...mapGetters('objectData', ['getHeaders', 'getStandard']),
        ...mapState(['language']),
        headers(){
            return {
                assetHeaders: this.getHeaders('asset'),
                groupHeaders: this.getHeaders('assetGroup'),
                encodeTableHeaders: this.getHeaders('encodeTable'),
                reqEncodeTableHeaders: this.getHeaders('reqEncodeTable'),
            }
        },
        // name_frame(){
        //     return this.$store.getters.t('프레임');
        // },
        // name_bitrate(){
        //     return this.$store.getters.t('비트레이트');
        // },
        // name_audio(){
        //     return this.$store.getters.t('음질');
        // },
        // name_preset(){
        //     return this.$store.getters.t('인코딩 속도');
        // },
        filteredItems(){
            // if(this.searchData){
            //     console.log("검색어 있음 : ", this.allDatas)
            //     return this.allDatas;
            // } else {
            //     console.log("검색어 x", this.tableDatas)
            //     return this.tableDatas;
            // }

            return this.search ? this.allDatas : this.tableDatas;
            // return this.tableDatas;
        },
        // assetInfo: {
        //    get(){
        //          if(this.tableDatas && this.dataLoad){
        //             const data = this.tableDatas.find(e => e.assetId === this.selectedId);
        //             // console.log("데이터 확인용 => ", data);
        //             return data;
        //         }
        //         return null;
        //    },
        //    set(){

        //    }
        // },
        standardVal(){
            return {
                checkData: this.getStandard('checkData'),
                fixedData: this.getStandard('fixedData'),
            }
        },
        socialUploadJobs() {
            return this.socialJobs;
        },
        hasActiveSocialJobs() {
            if (!Array.isArray(this.socialJobs)) return false;
            return this.socialJobs.some(job => {
                if (!job) return false;
                const doneStatuses = ['done', 'completed', 'failed'];
                return !doneStatuses.includes(job.status) && (job.progress ?? 0) < 100;
            });
        },
        computedHeaders() { 
            const headers = [{ text: '', value: 'label'}];  
            this.options.forEach(option => {
                headers.push({ text: option.label, value: option.label });
            });
            return headers;
        },
        hasNextPage() {
            return (this.currentPage * this.rowsPerPage) < this.totalPages;
        },
        totalLength() {
            return  Math.ceil(this.totalPages / this.rowsPerPage);
        },
        selected(){
            return this.groupList.filter(e => this.groupIds.includes(e.id));
        },
        encodeInfoList(){
            if(this.dataLoad && this.load && this.assetInfo){
                //console.log("확인 ==> ", [this.assetInfo].flatMap(e=> e))
                // console.log("여기확인 => ", this.assetInfo) 
                return [this.assetInfo].flatMap(e=> e);
            }
            return null;
            // return [this.assetInfo];
            // return [this.assetInfo].flatMap(e=> e);
          
        },
        fpsOptions() {
            // const val = this.encodeInfoList.map(e => e.upload_frames);
            if(this.dataLoad && this.tableDatas && this.assetInfo){
                const val = this.assetInfo.upload_frames;
                //console.log("val =>>>> ", val)

                const val01 = this.$store.getters.t(process.env.VUE_APP_ENCODING_OPTION1_VALUE1);
                const val02 = process.env.VUE_APP_ENCODING_OPTION1_VALUE2;
                const val03 = process.env.VUE_APP_ENCODING_OPTION1_VALUE3;

                //console.log("val01 =>>>> ", val01)
                //console.log("val02 =>>>> ", val02)
                //console.log("val03 =>>>> ", val03)

                if(this.extractNumbersFromString(val02) >= val){
                    return [val01, val03];
                }
                else {
                    return [val01, val02, val03];
                }
            }
            return null;
        }, 
        crfOptions() {
            const map = {};
            if (this.resolutions) {
                for (const item of this.resolutions) {
                    const resolution = item.label;
                    map[resolution] = this.setCrf(resolution);
                }
            }
            return map;
            // return null;
            // return [process.env.VUE_APP_ENCODING_OPTION2_KEY1, process.env.VUE_APP_ENCODING_OPTION2_KEY2, process.env.VUE_APP_ENCODING_OPTION2_KEY3];
        },
        audioOptions() {
            if(this.dataLoad && this.tableDatas && this.assetInfo){
                // const val = this.assetInfo.upload_bitrate;
                const val = this.assetInfo.upload_a_bitrate;

                const val01 = this.$store.getters.t(process.env.VUE_APP_ENCODING_OPTION3_VALUE1);
                const val02 = process.env.VUE_APP_ENCODING_OPTION3_VALUE2;
                const val03 = process.env.VUE_APP_ENCODING_OPTION3_VALUE3;
                const val04 = process.env.VUE_APP_ENCODING_OPTION3_VALUE4;
                const val05 = process.env.VUE_APP_ENCODING_OPTION3_VALUE5;

                if(this.extractNumbersFromString(val02) >= val){
                    return [val01, val03, val04, val05];
                }
                else {
                    return [val01, val02, val03, val04, val05];
                }
            }
            return null;
        },
        presetOptions() {
            return [process.env.VUE_APP_ENCODING_OPTION4_VALUE1, process.env.VUE_APP_ENCODING_OPTION4_VALUE2, process.env.VUE_APP_ENCODING_OPTION4_VALUE3, process.env.VUE_APP_ENCODING_OPTION4_VALUE4, process.env.VUE_APP_ENCODING_OPTION4_VALUE5];            
        },
        groupDatas(){
            return this.groupList;
        },
        // resolutions() {
        //     // get(){
        //         if(this.dataLoad && this.tableDatas){
        //             return this.updateResolutions()
        //         }
        //         return null;
        //     // },
        //     // set(newVal){
        //     //     return newVal;
        //     // }
        // },
        group_id() {
            return this.selectedGroupId;
        },
        pageTitle() {
            // return this.$store.getters.t(this.selectedGroupName);
            return this.selectedGroupName;
        },
        name(){
            if(this.load){
                return this.getName();
            }
            return null;
        },
        playerUrl(){
            if(this.load){
                return this.geUrl();
            }
            return null;
        },
        poster(){
            if(this.load){
                return this.getPoster();
            }
            return null;
        },
        isAll(){
            if(this.group_id === 'all'){
                // this.watchFlag = false;
                this.updateFlag(false);
                return false;
            } else {
                // this.watchFlag = true;
                this.updateFlag(true);
                return true;
            }
        },
        // filteredCards() {
        //     let filters;
        //     if (this.search.trim() === '') {
        //         filters = this.filteredItems;
        //     } else {
        //         const newSearch = this.search.toLowerCase();

        //         if(this.filteredItems){
        //                 filters = this.filteredItems.filter(item => {
        //                     const names = item.name.toLowerCase();
        //                     const tags = item.tag.map(e => e.tag_name.toLowerCase());
        //                     return names.includes(this.search) || tags.some(e => e.includes(newSearch));
        //                 });
        //         } else {
        //             filters = []; 
        //         }
        //     }

        //     return filters;
        // },
    },
    beforeDestroy() {
        if(this.interval){
            clearInterval(this.interval);
        }
        this.stopSocialPolling();
        this.$store.commit('asset/setSearch', '');
        //const id = 'all';
      //  this.$store.dispatch('group/updateSelectedGroupId', id);
        // this.$watch();
    },
    watch: {
        socialUploadJobs: {
            handler(newVal, oldVal) {
            const newCount = Array.isArray(newVal) ? newVal.length : 0;
            const oldCount = Array.isArray(oldVal) ? oldVal.length : 0;

            if (newCount === 0) {
                this.showSocialStatusModal = false;
                this.socialStatusManuallyHidden = false;
                this.syncSocialPollingState();
                return;
            }

            if (this.showSocialStatusModal) {
                this.syncSocialPollingState();
                return;
            }

            if (!this.socialStatusManuallyHidden) {
                this.showSocialStatusModal = true;
                this.syncSocialPollingState();
                return;
            }

            if (newCount > oldCount) {
                this.socialStatusManuallyHidden = false;
                this.showSocialStatusModal = true;
            }
            this.syncSocialPollingState();
        },
        deep: true,
        immediate: false,
        },
        // tableDatas: _.debounce(function(newVal, oldVal) {
            filteredItems: _.debounce(async function (newVal, oldVal) {
            // console.log("newval => ", newVal);
            if (this.dataLoad && newVal && newVal !== oldVal){
                // this.handleDataUpdata(newVal || oldVal);
                if (!this.intervalRunning) {
                    this.dataLoading();
                    
                }
                if (this.watchFlag) {
                    const params = {
                        group_id: this.group_id,
                        page: this.currentPage,
                        rowsPerPage: 10
                    };
                    const res = await this.fetchGroupListItems(params);
                    if (res.status === 1) {
                        this.tableDatas = res.list;
                        //console.log("this.tableDatas => ", this.tableDatas)
                        this.$store.commit('asset/setTotal', res.total);
                        this.$store.dispatch('asset/updateCurrentPage', this.currentPage);
                        //console.log("res.list => ", res.list)
                        this.$store.commit('asset/setLoading', false);
                        //this.dataLoading();
                    }
                }
            }
        }, 5000),
        

        lastCompletedFileName(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.interval = setInterval(this.dataLoading.bind(this), 5000);
            }
        },
        itemsPerPageOptions(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.dataLoading();
            }
        },
        snackbarText(newVal, oldVal){
            if (newVal && newVal !== oldVal) {
                // console.log("snackbarText : ", newVal)
                this.interval = setInterval(this.dataLoading.bind(this), 5000);
            }
        },
        group_id: {
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.assetIds = [];
                    // this.updateDrawer(false);
                    //console.log("새로운 값 group_id => ", newValue)
                    this.tableDatas = [];
                    this.$store.commit('asset/setLoading', true);

                    if(newValue !== 'all'){
                        // this.watchFlag = true;
                        this.updateFlag(true);
                        const params = {
                            group_id: newValue,
                            page: 1,
                            rowsPerPage: 10
                        };
                        const res = await this.fetchGroupListItems(params);
                        if(res.status === 1){
                            this.tableDatas = res.list;
                            //console.log("this.tableDatas => ", this.tableDatas)
                            this.$store.commit('asset/setTotal', res.total);
                            this.$store.dispatch('asset/updateCurrentPage', 1);

                            // 추가
                            if(this.tableDatas){
                                this.$store.commit('asset/setDataLoad', true);
                            } else {
                                this.$store.commit('asset/setDataLoad', false);
                            }
                            //console.log("res.list => ", res.list)
                            this.$store.commit('asset/setLoading', false);
                        } 
                    } else {
                        // this.watchFlag = false;
                        this.updateFlag(false);
                        this.$store.commit('asset/setLoading', true);
                        this.dataLoading();
                        this.$store.commit('asset/setTotal', this.initTotal);
                        this.$store.dispatch('asset/updateCurrentPage', 1);
                       
                        // 추가
                        if(this.tableDatas){
                            this.$store.commit('asset/setDataLoad', true);
                        } else {
                            this.$store.commit('asset/setDataLoad', false);
                        }

                        this.$store.commit('asset/setDataLoad', true);
                        this.$store.commit('asset/setLoading', false);
                        this.$store.dispatch('group/updateSelectedGroupId', newValue);
                    }
                    // console.log("watchFlag", this.watchFlag)
                }
            },
            immediate: true,
            deep: true
        },
        language(newVal, oldVal) {
            if(newVal != oldVal){
                this.fetchOptions();
                
            }
        },
    },
    created(){

      
        
        // this.flag = false;
        // this.dataLoading().then(() => {
        //     this.$watch(
        //         () => this.tableDatas, (newVal, oldVal) => {
        //             // console.log("watch실행? ", newVal);
        //             // if(this.dataLoad && newVal != oldVal && !this.watchFlag){
        //             //     this.handleDataUpdata(newVal || oldVal);
        //             //     // watchFlag = true -> show grouplist
        //             // }
        //             if(this.dataLoad && newVal != oldVal){
        //             //    if(this.watchFlag02){
        //             //         console.log("");
        //             //    }
        //             //    else {
        //                     if(!this.watchFlag){
        //                         // console.log("watch실행? ", newVal);
        //                         this.handleDataUpdata(newVal || oldVal);
        //                     }
        //                     else {
        //                         // console.log("watch실행x ");
        //                         // show grouplist
        //                     }
        //             //    }
        //             }
                    
        //         },
        //         {deep: true}
        //     );
        //     // this.$watch(
        //     //     () => this.tableDatas, (newVal, oldVal) => { console.log("watch실행? ", newVal); this.tableDatas = newVal;}
        //     // )
        // });
        // this.flag = true;
        // this.fetchOptions();
        if(this.groupList.length === 0) {
            // console.log("리스트 존재 하지 않음 로딩 중...")
             this.getGroups();
        }
        else {
            // console.log("리스트 이미 존재 => ", this.groupList)
        }

        this.fetchAll();

        try {
            
            this.bitrateOptions = JSON.parse(process.env.VUE_APP_BITRATE_OPTIONS || '{}');
            // console.log("bitrateOptions 1=> ", process.env.VUE_APP_BITRATE_OPTIONS)
            // console.log("bitrateOptions 2=> ", this.bitrateOptions)
        } catch (error) {
            console.log("err => ", error)
        }


        // this.$on('progress-updated', this.dataLoading);
    },
    // beforeDestroy() {
    //     this.$off('progress-updated', this.dataLoading);
    // },

    mounted() {



        // this.dataLoading();
        this.fetchSocialJobsFromStore().finally(() => {
            this.syncSocialPollingState();
        });
        if(!this.search){
            this.interval = setInterval(this.dataLoading.bind(this), 5000);   
        }

        // if(this.dataLoad && this.tableDatas){
        //     // this.searchList = await this.fetchAllList();
        //     // console.log("this.searchList : ", this.searchList)
        // }
        // this.updateSelectedGroupId('all');
        if(this.group_id != 'all'){
            this.$store.dispatch('group/updateSelectedGroupId', this.group_id);
        } else {
            const id = 'all';
            this.$store.dispatch('group/updateSelectedGroupId', id);
        }
        // this.watchFlag = false;
        // this.updateFlag(false);
        
        // 언어 변경이 적용될 수 있도록 약간의 지연 후에 강제 렌더링
        setTimeout(() => {
            this.$forceUpdate();
        }, 100);
    },

    
    
    // mounted() {
    //     // window.addEventListener('resize', this.handleResize); 
    //     // console.log("this.$refs.assetPlayer => ", this.$refs.assetPlayer)
    //     console.log('클릭')
    //     this.$on('openPlayerModal', this.openPlayerModal);
    // },
    // destroyed() {
    //     this.$off('openPlayerModal', this.openPlayerModal);
    //     // window.removeEventListener('resize', this.handleResize); 
    // },

    // beforeDestroy() {
    //     this.$store.asset.statusList; 
    // }

    // created() {
    //     console.log("확인")
    //     this.$store.subscribe((mutation, state) => {
    //         if (mutation.type === 'setStatus') {
    //             this.fetchStatus().catch(error => {
    //                 console.error('error', error);
    //             });
    //         }
    //     });
    // },
  };
</script>

<template>
    <div class="Background">
         <!-- <h2 v-if="!isEditing" class="Title"> -->
        <div class="link_location">
             <h2 class="Title">
                {{ $store.getters.t('VOD 관리') }} <v-icon class="mdi mdi-chevron-right" /> <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t(pageTitle) }}</span>
            </h2>
        </div>
            <!-- <v-btn v-show="isAll" icon @click="toggleEditing"> <v-icon class="mdi mdi-pencil-outline"></v-icon></v-btn>
        </h2> -->
        <!-- <div v-else style="height: 37px;margin-bottom: 18px;">
            <v-row>
                <v-col cols="2">
                <v-text-field dense v-model="editedGroupName" @keyup.enter="saveGroupName" style="font-size: 24px;font-weight: bold; padding: 0px;"/>
                </v-col>
                <v-col cols="1">
                <v-btn icon @click="saveGroupName"> <v-icon class="mdi mdi-check"></v-icon></v-btn>
                </v-col>
                <v-col cols="2" v-if="dulp">
                    <Alert :message="message" :message-type="messageType"></Alert>
                </v-col>
            </v-row>
        </div> -->
        <v-row>
            <v-col cols="5">
                <SearchTextfield :search="search" :placeholder="$store.getters.t('동영상 제목 또는 태그로 동영상 찾기')"/>
                 <!-- <div>
                    <v-icon class="mdi mdi-magnify search-icon"/>
                    <input 
                        :placeholder="$store.getters.t('동영상 제목 또는 태그로 동영상 찾기')" 
                        v-model="searchData" 
                        @compositionstart="isComposing = true"
                        @compositionend="onCompositionEnd"
                        @input="onInput"
                        class="search-input">
                </div> -->
            </v-col>
            <v-col class="text-right mb-2">
                <!-- <v-btn-toggle v-model="toggle_exclusive" class="mr-2">
                    <IconButton icon="mdi-format-list-bulleted" small :active="showDataTable" @click="showDataTable = false"/>
                    <IconButton icon="mdi-apps" small :active="!showDataTable" @click="showDataTable = true"/>
                </v-btn-toggle> -->

                <IconButton icon="mdi-refresh" class="mr-2 mb-2" @click="refresh" small buttonheight="36px"/>
                <!-- <IconButton icon="mdi-youtube" IconColor="red" class="mr-2" /> -->
                <TextButton :disabled="assetIds.length === 0" icon="mdi-plus" :buttonText="$store.getters.t ? $store.getters.t('그룹화') : '그룹화'" class="mr-2 mb-2" isPrimary  @click="openModal('groupDialog')"/>
                <IconButton :disabled="assetIds.length === 0" icon="mdi-trash-can-outline" @click="openModal('delDialog')" small class=" mb-2" />
            </v-col>

            <!-- <AssetInfoDrawer :drawer="drawer" :closeBtn="closeBtn" :assetInfo="assetInfo" :openPlayerModal="openPlayerModal"
           :playDialog="playDialog" :checkClick="checkClick"  :editBtn="editBtn" :delBtn="delBtn">
            </AssetInfoDrawer> -->
            <div>
                <!-- <AssetInfoDrawer 
                    @reload-data="dataLoading" 
                    :playVideo="playVideo" 
                    :resolutions="resolutions" 
                    :drawer="drawer" 
                    :closeBtn="closeBtn" 
                    :checkReq="checkReq" 
                    :assetInfo="assetInfo" 
                    :checkClick="checkClick" 
                    :editBtn="editBtn" 
                    :delBtn="delBtn">
             </AssetInfoDrawer> -->
             <AssetDrawer 
                    @reload-data="dataLoading" 
                    :drawer="drawer"
                    @close-drawer="closeBtn"
                    @delete-encodeFile="delBtn"
                    @move-edit="editBtn"
                    @check-click="checkClick"
                    @play-video="playVideo"/>
            </div>
            
            
        </v-row>

        <v-col>

            <!-- 카드형식 ui -->
            <!-- <AssetCard v-if="dataLoad && !showDataTable" :items="filteredCards" :rowClick="showInfo"/> -->
            <!-- <v-row v-if="!showDataTable">
                <v-col v-for="(item, index) in tableDatas" :key="index" cols="12" md="4" class="pa-0" @click="showInfo(item)">
                    <v-card v-if="CardSearch(item)"  @click="toggleCardSelection(item)" elevation="0" outlined class="asset_card ma-2">
                        
                        <div class="image-container">
                            <v-img :src="getImage(item.image)" :contain="true" style="position: absolute;top: 0;width: 100%;height: 100%;">
                                <v-checkbox v-model="item.assetIds" @click.stop class="ma-3" dark></v-checkbox>
                                
                                <span class="asset_runtime">{{ item.runtime }}</span>
                                
                            </v-img>
                        </div>
                        
                        <div class="pa-4">
                            <h4 class="card-heading pb-1">{{ item.name }}</h4>
                            <span class="asset_uploadtime mr-2">{{ item.upload_time }}</span>
                            <template v-if="item.groupData.length <= 2">
                                <span v-for="(group, index) in item.groupData" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                                    {{ group }}
                                </span>
                            </template>
                            <template v-else>
                                <span v-for="(group, index) in item.groupData.slice(0, 1)" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                                    {{ group }}
                                </span>
                                <span class="asset_group_more">
                                    외 {{ item.groupData.length - 1 }}개
                                </span>
                            </template>
                        </div>
                        
                        <AssetDataChip v-for="(item, index) in tableDatas" :key="index" :data="item"/>
                        
                    </v-card>
                </v-col>
            </v-row> -->

            <AssetDataTable v-if="dataLoad && showDataTable"
            :headers="headers.assetHeaders"
            :items="filteredItems"
            :loading="loading"
            :search="search"
            :rowsPerPage="rowsPerPage"
            :enterSelect="enterSelect"
            :value="assetIds"
            :rowClick="showInfo"
             @uploadFinished="handleUploadFinished"
            >            
                <!-- <template v-slot:item.image="{ item }">
                    <img :src="item.image" width="150px" style="margin" class="mt-2">
                </template> -->
            <!-- <template v-slot:item.image="{ item }">
                    <img src="@/styles/assets/live_manual1.png" width="150px" style="margin" class="mt-2">
                </template>-->

                <!-- <template v-slot:item.protein="{ item }">
                    <Chips chipText="1080p" />
                    <Chips chipText="720p" />
                    <v-progress-circular
                    :rotate="180"
                    :size="40"
                    :width="6"
                    :value="value"
                    >
                        <span style="font-size: 12px;">20%</span>
                    </v-progress-circular>
                </template>  -->
            </AssetDataTable>
            
            <!-- <div  style="display: flex; align-items: center; justify-content: flex-end;">
                <v-select :value="rowsPerPage" style="max-width: 60px;" :items="itemsPerPageOptions" variant="outlined" @input="updatePageRow"></v-select>
                <v-pagination class="my-3" v-model="currentPage" :length="totalLength" :total-visible="5"  @input="updatePage"></v-pagination>
            </div> -->

            <div v-if="dataLoad" style="display: flex; background-color: white; height:45px; align-items: center; justify-content: flex-end;">
                <div>
                    <v-select :value="rowsPerPage" style="max-width: 60px;" :items="itemsPerPageOptions" variant="outlined" @input="updatePageRow"></v-select>
                </div>
                <!--전체리스트-->
                <div v-if="!watchFlag" class="paging_box ml-5"> 
                    <span>{{ startIndex }}-{{ endIndex }} of {{ totalPages }}</span>
                    <v-btn @click="previousPage" :disabled="currentPage === 1"
                        icon><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <v-btn @click="nextPage" :disabled="!hasNextPage" icon><v-icon>mdi-chevron-right</v-icon></v-btn>
                </div>
                 <!--그룹리스트-->
                <div v-if="watchFlag" class="paging_box ml-5">
                    <span>{{ this.currentPage }}-{{ endIndex }} of {{ totalPages }}</span>
                    <v-btn @click="previousPage" :disabled="currentPage === 1"
                        icon><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <v-btn @click="nextPage" :disabled="!hasNextPage" icon><v-icon>mdi-chevron-right</v-icon></v-btn>
                </div>
            </div>

 

            <!-- <v-data-table 
            :headers="headers"
            :items="desserts"
            :single-select="singleSelect"
            item-key="name"
            show-select
            class="data-table elevation-0"
            height="400px"
            fixed-header
            >
                <template v-slot:item.image="{ item }">
                    <img src="@/styles/assets/live_manual1.png" width="150px" style="margin" class="mt-2">
                </template>

                <template v-slot:item.protein="{ item }">
                    <Chips chipText="1080p" />
                    <Chips chipText="720p" />
                    <v-progress-circular
                    :rotate="180"
                    :size="40"
                    :width="6"
                    :value="value"
                    >
                        <span style="font-size: 12px;">20%</span>
                    </v-progress-circular>
                </template>

            </v-data-table> -->
            
        </v-col>

        <!-- 에셋 그룹핑 Modal -->
        <AppDialog :value="groupDialog" :persistent="true" @input="groupDialog = $event">
            <template v-slot:title>
                <span>{{ $store.getters.t('그룹화 설정') }}</span>
            </template>
            <!-- <template v-slot:close>
                <v-icon @click="closeDialog('groupDialog')">mdi-close</v-icon>
            </template> -->
            <template v-slot:content>
                <v-data-table :headers="headers.groupHeaders" :items="groupList"   show-select item-key="id" 
                :page.sync="page"
                @page-count="pageCount = $event"
                :items-per-page="viewCount"
                :value="selected"  @input="updateSelected" class="data-table mb-2" hide-default-footer fixed-header height="220px"/>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </template>
            <template v-slot:actions>
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="closeDialog('groupDialog')" />
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('그룹화') : '그룹화'"  @click="inGroup" isPrimary :loading="inGroupLoading"/>
            </template>
        </AppDialog>

         <!-- 삭제 Modal -->
         <AppDialog :value="delDialog" :persistent="true" @input="delDialog = $event">
            <template v-slot:title>
                <span>{{ $store.getters.t('동영상 삭제') }}</span>
            </template>
            
                <!-- <templadivte v-slot:close>
                    <v-icon @click="closeDialog('delDialog')">mdi-close</v-icon>
                </templadivte> -->
            
            
            <template v-slot:content>
                <span>{{ $store.getters.t('선택한 동영상의 원본 및 인코딩 파일이 모두 삭제됩니다. 삭제하시겠습니까?') }}</span>
            </template>
            <template v-slot:actions>
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="closeDialog('delDialog')" />
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('삭제') : '삭제'"  @click="delAssets" isPrimary :loading="allDelLoading"/>
            </template>
        </AppDialog>

        <!-- 인코딩 선택 옵션 Modal -->
        <AppDialogLarge :value="encodeDialog" :persistent="true" @input="encodeDialog = $event">
            <template v-slot:title>
                <v-col>
                    <span>{{ $store.getters.t('동영상 인코딩') }}</span>
                </v-col>
                <v-col class="text-right">
                    <TextButton :buttonText="$store.getters.t ? $store.getters.t('초기화') : '초기화'" :small="true" @click="clearOption" />
                </v-col>
            </template>
            <!-- <template v-slot:close>
                <v-icon @click="closeDialog('encodeDialog')">mdi-close</v-icon>
            </template> -->
            <template v-slot:content>
                <!-- <DataTable :load="load" :headers="headers.encodeTableHeaders" :datas="encodeInfoList" class="mb-3"> -->
                <DataTable :headers="headers.encodeTableHeaders" :type="'type01'" class="mb-3"/>
                <EncodeOptionTable :load="load" :headers="computedHeaders" :datas="resolutions" 
                :itemKey="'label'" :selected01="selected01" :selected02="selected02" :options="options" @update:selected01="updateSelected01">
                </EncodeOptionTable>
                <Alert :message="message" :message-type="messageType"></Alert>
            </template>
            <template v-slot:actions>
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="closeDialog('encodeDialog')" />
                <TextButtonBlock isPrimary :buttonText="$store.getters.t ? $store.getters.t('등록') : '등록'" @click="handleConfirmation" />
            </template>
        </AppDialogLarge>

        <!-- req encode Info table Modal -->
        <AppDialogLarge :value="reqEncodeDialog" :persistent="true" @input="reqEncodeDialog = $event">
            <template v-slot:title>
                <span>{{ $store.getters.t('동영상 인코딩') }}</span>
            </template>
            <!-- <template v-slot:close>
                <v-icon small @click="closeDialog('reqEncodeDialog')">mdi-close</v-icon>
            </template> -->
            <template v-slot:content>
                <!-- <DataTable v-if="dataLoad" :load="load" :headers="headers.reqEncodeTableHeaders" :datas="reqEncodeList">
                    
                </DataTable> -->
                 <DataTable :headers="headers.reqEncodeTableHeaders" :datas="reqEncodeList"/>
            </template>
            <template v-slot:actions>
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="closeDialog('encodeDialogAll')"></TextButtonBlock>
                <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('인코딩') : '인코딩'" isPrimary @click="sendReqEncode"></TextButtonBlock>
            </template>
        </AppDialogLarge>

         <!-- player Modal -->
        <AssetPlayer :compType="false" v-if="playVal" :poster="poster" :playVal="playVal" :playUrl="playerUrl" :playerName="name" :closeVideo="closeVideo" />
       
        <!-- 인코딩 단일 파일 삭제 확인 modal -->
        <AppDialog :value="delConfirm" :persistent="true" @input="delConfirm = $event">
            <template v-slot:title>
                <span>{{ $store.getters.t('인코딩 파일 삭제') }}</span>
            </template>
        
            <template v-slot:close>
                <div style="float: right;">
                    <v-icon small @click="closeDialog('delConfirm')">mdi-close</v-icon>
                </div>
            </template>
        
        
        <template v-slot:content>
        <span>{{ $store.getters.t('선택한 인코딩 파일을 삭제하시겠습니까?') }}</span>
        </template>
        <template v-slot:actions>
            <v-btn :loading="delEncodeLoading" @click="deleteEncodeFile">{{ $store.getters.t('삭제') }}</v-btn>
        </template>
    </AppDialog>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <SocialUploadStatusAccordion
        v-if="showSocialStatusModal && socialUploadJobs.length"
        :items="socialUploadJobs"
        :bulk-hiding="bulkHideLoading"
        @hide="handleSocialJobHide"
        @cancel="handleSocialJobCancel"
        @hide-all="handleSocialHideAll"
        @close="handleSocialStatusClose"
    />
        
    </div>
</template>
    
<style scoped>
.table_title{
    width: 200px;
    font-size: 16px;
    background-color: #F8F8F8;
    border-bottom: 1px solid #DFDFDF;
}

.table_text{
    border-bottom: 1px solid #DFDFDF;
}
.text-left { width: 21%; }
.bitrate_text {font-size: 12px;color: #bbb;}

.asset_card{
    border-radius: 12px;
}
.asset_runtime{
    position: absolute;
    bottom: 10px;
    right:10px;
    background: rgba(0, 0, 0, 0.5);
    color:#fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
}
.asset_group {
    color: #fff;
    background: rgba(141, 141, 141, 0.6);
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 4px;
    font-size: 12px;
}
.asset_group_more{
    color: #aaa;
    font-size: 12px;
}
.card-heading {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.asset_uploadtime{
    font-size: 14px;
    color:#999
}
.image-container{
    background-color: black;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    width:100%;
    overflow: hidden;
    
}
.selected {
    border:2px solid #006CEA;
}

.search-input {
    width: 70%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
    padding-left: 36px;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}

</style>
